import React from 'react';

import CommonImage from '@/components/CommonImage';
const AutherziationPage = () => {
	return (
		<div className="authorization-page bg-white">
			<div className="authorization-content d-flex align-items-center justify-content-center">
				<h1 className="mr-4 gray_dark_01">Authorize...</h1>
				<span className="authorization-loader">
					<CommonImage src="/icons/Load.svg" width={45} height={45} />
				</span>
			</div>
		</div>
	);
};

export default AutherziationPage;
